import '@/assets/scss/app.scss'

import Vue from 'vue'
import App from './App'
import store from '@/store'
import router from '@/router'
import './registerServiceWorker'
import '@/utils/layouts' // eslint-disable-line no-unused-vars
import '@/utils/components' // eslint-disable-line no-unused-vars
import '@/utils/filters' // eslint-disable-line no-unused-vars
import bootstrap from '@/resources/bootstrap' // eslint-disable-line no-unused-vars

Vue.config.productionTip = false

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
